<div id="wrap" class="moWrap">
    <header class="header">
        <div class="header_inner">
            <a a routerLink="/m/mypage" class="btn_prev"><span class="blind">이전 페이지로 이동하기</span></a>
            <h1 class="header_logo">
                <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
            </h1>
            <span class="util_right">
                <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
            </span>
        </div>
    </header>

    <div id="content">
    <div id="skip_anchor" class="content page_link">
            <div class="compt_tab">
                <button type="button" [ngClass]="tab == 'add' ? 'active' : ''" (click)="tabSelect('add')" class="compt_tab_item">링크 만들기</button><!-- 활성화된 탭 메뉴 "active" -->
                <button type="button" [ngClass]="tab == 'list' ? 'active' : ''" (click)="tabSelect('list')" class="compt_tab_item">링크목록</button>
            </div>
            <div class="compt_cont">
                <!-- 링크 만들기 -->
                <div class="compt_inner url" [ngClass]="tab == 'add' ? 'active' : ''">
                    <div class="compt_top">
                      <p>&#8251;링크를 생성한 제품 외에도 구매가 이루어진 모든 제품에 대해 수수료를 지급해드리고 있습니다.</p>
                    </div>
                    <strong class="compt_title">1) URL 입력</strong>
                    <p class="compt_desc">게시할 링크를 복사하여 아래 입력칸에 붙여넣기 후 생성 버튼을 눌러주세요.</p>
                    <div class="form mt-18">
                        <input type="text" [(ngModel)]="linkUrl" (keyup.enter)="addLinkUrl()" id="channelUrl-2" class="form_input" placeholder="https://" />
                    </div>
                    <div class="form mt-12">
                        <button type="button" (click)="addLinkUrl()"  class="form_button btn-success w-full">생성하기</button>
                    </div>
                    <ng-container *ngIf="addedList && addedList.length > 0">
                        <strong class="compt_title">2) 별도링크 생성 완료</strong>
                        <ul class="link_list mb-50">
                            <li class="item" *ngFor="let item of addedList">
                                <div class="img_area"><img src="{{item.filePath}}" alt="{{item.title}}" onerror="this.src='/assets/images/web/img/img_onerrer.jpg'" /></div>
                                <div class="info_area">
                                    <span class="info_area_type">{{item.urlTypeName}}</span>
                                    <strong class="info_area_title ellipsis">{{item.title}}</strong>
                                    <a href="https://www.oasis.co.kr{{item.urlValue}}" target="_blank" class="info_area_link ellipsis">https://www.oasis.co.kr{{item.urlValue}}</a>
                                </div>
                                <div class="btn_area">
                                    <button type="button" (click)="copyUrl(item)" class="form_button form_button-min btn-success-line">링크복사</button>
                                </div>
                            </li>
                        </ul>
                    </ng-container>
                    <div class="content_notice mt-50">
                        <strong class="content_notice_title">
                            <input type="checkbox" id="precautions" class="blind" />
                            <label for="precautions">활동 시 주의사항</label>
                        </strong>
                        <ol class="content_notice_list">
                            <li class="content_notice_item">버디 활동으로 게시된 모든 콘텐츠에 아래 문구를 반드시 표기하셔야 합니다. <br />“이 포스팅은 오아시스 버디 활동의 일환으로 이에 따른 일정액의 수수료를 제공 받을 수 있습니다.” <br />(소비자가 쉽게 볼 수 있는 위치에 노출해야 하며, 더보기를 클릭해야만 보이는 등 즉시 알아볼 수 없는 형태로 제공 시 위반 사례가 될 수 있음)</li>
                            <li class="content_notice_item">표시 문구는 각 게시물의 제목 또는 첫 부분에 게재해야 하며, 광고 또는 수익배분 단어를 표시해야 합니다. <br />
                                &lt;인스타그램 예시 - 아래 중 1개 이상 진행 필수&gt;<br />
                                - 게시글 본문 첫 줄에 ‘광고’ 표시 <br />
                                - 게시글 사진 내 ‘광고’ 표시 <br />
                                - 게시글 본문 첫번째 해시태그에 ‘광고’ 표시 <br />
                                <p class="mt-6">오아시스 버디 활동은 공정위 심사지침에 따라 회원과 당사의 경제적 이해관계에 대하여 공개하여아 합니다. <br />대가성 문구가 기입되지 않은 오아시스 버디 활동 게시물이 확인되는 경우 문구 표기 요청 및 채널 반려 안내가 진행될 수 있습니다. <br />보다 자세한 내용은 아래 정부지침을 참고해주시기 바랍니다.</p>
                                <a href="https://oasisprodcom.edge.naverncp.com/buddy/data/경제적_이해관계_표시_안내서_공정거래위원회_보도자료_20200830.pdf" target="_blank" download="[별첨1] 경제적 이해관계 표시 안내서(공정거래위원회 보도자료 2020. 8. 30).pdf" role="button" class="btn_download">경제적 이해관계 표시 안내서PDF.pdf</a>
                            </li>
                        </ol>
                    </div>
                </div>
                <!-- //링크 만들기 -->

                <!-- 링크목록 -->
                <div class="compt_inner link" [ngClass]="tab == 'list' ? 'active' : ''">
                    <ng-container *ngIf="list && list.length > 0">
                        <ul class="link_list">
                            <li class="item" *ngFor="let item of list" [ngClass]="item.isOpen ? 'open' : ''">
                                <button type="button" (click)="linkDetail(item)" class="img_area"><img src="{{item.filePath}}" alt="{{item.title}}" onerror="this.src='/assets/images/web/img/img_onerrer.jpg'" /></button>
                                <button type="button" (click)="linkDetail(item)" class="info_area">
                                    <span class="info_area_type">{{item.urlTypeName}} <span class="info_area_date">{{item.regDate | date: 'MM.dd HH:mm'}} 생성</span></span>
                                    <strong class="info_area_title ellipsis">{{item.title}}</strong>
                                    <span class="info_area_link">자세히 보기</span>
                                </button>
                                <div class="btn_area">
                                    <button type="button" (click)="copyUrl(item)" class="form_button form_button-min btn-success-line">링크복사</button>
                                </div>
                                <dl class="item_info">
                                    <dt class="item_info_title">타입</dt>
                                    <dd class="item_info_desc">{{item.urlTypeName}}</dd>
                                    <dt class="item_info_title">링크명</dt>
                                    <dd class="item_info_desc">{{item.title}}</dd>
                                    <dt class="item_info_title">URL</dt>
                                    <dd class="item_info_desc">https://www.oasis.co.kr{{item.urlValue}}</dd>
                                    <dt class="item_info_title">등록</dt>
                                    <dd class="item_info_desc">{{item.regDate | defaultDate}}</dd>
                                </dl>
                            </li>
                        </ul>
                    </ng-container>
                    <ng-container *ngIf="!(list && list.length > 0)">
                        <p class="no_list">생성된 링크가 없습니다.</p>
                    </ng-container>
                </div>
                <!-- //링크목록 -->
            </div>
        </div>
    </div>
</div>
